import * as actions from './actions';

const initialState = {
    stats: null,
    error: null,
    initial: false,
    loading: false,
};

const globalStatsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.FETCH_GLOBAL_STATS.REQUEST:
            return { ...state, loading: true, error: null };

        case actions.FETCH_GLOBAL_STATS.SUCCESS: {
            const { stats } = action.payload;
            return { ...state, loading: false, initial: true, stats };
        }

        case actions.FETCH_GLOBAL_STATS.FAILURE:
            return { ...state, loading: false, initial: false, error: action.payload.error };

        default:
            return state;
    }
};

export default globalStatsReducer;
